import React from 'react';
import './NoRegistrationMessage.css';

const NoRegistrationMessage = () => {
    return (
        <div>
            <div className="pl-1 subject-page-content" style={{paddingTop: '0.5rem'}}>
            <div className="container pt-6" style={{ maxWidth: "768px" }}>
              <div className="columns">
                <div className="column">
                  <div className="notification is-info is-flex">
                    <span className="icon mr-4">
                      <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24">
                        <path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path>
                      </svg>
                    </span>
                    <span>You have not registered any students for this subject.</span>
                  </div>
                </div>
              </div>
              <div className="has-background-white-ter content card p-4">
                <h3 className="title is-4">Next steps</h3>
                <p>
                  Your exams officer will need to make registration entries for this
                  subject before you can request a visit. Entries can be submitted via
                  <strong> A2C </strong> or <strong> Interchange</strong>.
                </p>
                <p className="xbox xnotification is-info mt-4">
                  If you need help, please contact <a href="mailto:support@ocr.org.uk">support@ocr.org.uk</a>.
                </p>
              </div>
            </div>
          </div>
        </div>
    )
}

export default NoRegistrationMessage;